import { Button, Card, CardContent, CardHeader, CardTitle } from '@1trading/react';
import { ArrowLeft } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';
import { AccountCleanupReview } from '@/features/account-cleanup/account-cleanup-review';
import { extractFileName } from '@/utils/string';

const BACK_TO = '/operations/user-audit/cleanup';

const AccountCleanupReviewPage = () => {
  const [searchParams] = useSearchParams();
  const reportKey = searchParams.get('key');

  return (
    <Card>
      <CardHeader className="flex flex-row flex-wrap items-center justify-between gap-3 space-y-0">
        <div className="flex flex-col gap-1">
          <CardTitle>Account Cleanup Review</CardTitle>
          {reportKey ? <span className="font-mono text-xs text-muted-foreground">{extractFileName(reportKey)}</span> : null}
        </div>
        <Button asChild className="gap-2" size="sm" type="button" variant="outline">
          <Link to={BACK_TO}>
            <ArrowLeft className="size-4" />
            Back to Account Cleanup
          </Link>
        </Button>
      </CardHeader>
      <CardContent>
        {reportKey ? (
          <AccountCleanupReview key={reportKey} reportKey={reportKey} />
        ) : (
          <p className="text-sm text-muted-foreground">No report selected. Pick one from the Account Cleanup list.</p>
        )}
      </CardContent>
    </Card>
  );
};
AccountCleanupReviewPage.displayName = 'AccountCleanupReviewPage';

export default AccountCleanupReviewPage;
